import template from "./agency-picker.html";
import "./agency-picker.less";
import { FuzzySearcher } from "../../utils/fuzzy-search";
import { AGENCY_FUZZY_OPTIONS } from "./agency-search";

let agencyPickerInstanceCount = 0;

export function controller($timeout, $logger) {
	const ctrl = this;
	const agencySearcher = new FuzzySearcher([], AGENCY_FUZZY_OPTIONS);

	ctrl.$onInit = onInit;
	ctrl.$onChanges = onChanges;
	ctrl.filteredAgencies = [];
	ctrl.isAgencyListExpanded = false;
	ctrl.agencyQuery = "";
	ctrl.selectAgency = selectAgency;
	ctrl.toggleAgencyList = toggleAgencyList;
	ctrl.onAgencyQueryChanged = onAgencyQueryChanged;
	ctrl.closeAgencyList = closeAgencyList;

	function onInit() {
		ctrl.instanceId = ++agencyPickerInstanceCount;
		ctrl.placeholderText = ctrl.placeholderText || "Select an agency";
		ctrl.searchInputId = `agency-search-${ctrl.instanceId}`;
		ctrl.listboxId = `agency-listbox-${ctrl.instanceId}`;
		ctrl.filteredAgencies = ctrl.agencies || [];
		if(shouldAutoSelectInitialAgency()) {
			ctrl.selectedAgency = ctrl.selectedAgency || ctrl.agencies[0];
		}
		else if(shouldOpenWhenEmpty()) {
			openAgencyList();
		}
	}

	function onChanges(changes) {
		if(changes.agencies) {
			ctrl.filteredAgencies = getFilteredAgencies(ctrl.agencyQuery);
			if(shouldAutoSelectInitialAgency()) {
				ctrl.selectedAgency = ctrl.selectedAgency || ctrl.agencies[0];
			}
			else if(shouldOpenWhenEmpty()) {
				openAgencyList();
			}
		}

		if(changes.selectedAgency?.currentValue) {
			ctrl.selectedAgency = changes.selectedAgency.currentValue;
		}
		else if(changes.selectedAgency && ctrl.autoSelectInitial === false) {
			ctrl.selectedAgency = undefined;
		}
	}

	function toggleAgencyList() {
		if(ctrl.isAgencyListExpanded) {
			closeAgencyList();
			return;
		}

		openAgencyList();
	}

	function closeAgencyList() {
		ctrl.isAgencyListExpanded = false;
		ctrl.agencyQuery = "";
		ctrl.filteredAgencies = ctrl.agencies;
		emitExpandedChanged();
	}

	function onAgencyQueryChanged() {
		ctrl.filteredAgencies = getFilteredAgencies(ctrl.agencyQuery);
	}

	function selectAgency(agency) {
		if(!agency) {
			return;
		}

		ctrl.selectedAgency = agency;
		closeAgencyList();

		if(ctrl.onAgencySelected) {
			ctrl.onAgencySelected({ $event: { agency: ctrl.selectedAgency } });
		}
	}

	function getFilteredAgencies(queryText) {
		const trimmedQuery = (queryText || "").trim().toLowerCase();
		const agencies = ctrl.agencies || [];

		if(!trimmedQuery) {
			return agencies;
		}

		agencySearcher.setCollection(agencies);

		return agencySearcher.searchRaw(trimmedQuery).map((result) => result.item);
	}

	function shouldAutoSelectInitialAgency() {
		return ctrl.autoSelectInitial !== false && ctrl.agencies?.length;
	}

	function shouldOpenWhenEmpty() {
		return ctrl.openWhenEmpty === true && !ctrl.selectedAgency && ctrl.agencies?.length;
	}

	function openAgencyList() {
		ctrl.isAgencyListExpanded = true;
		ctrl.agencyQuery = "";
		ctrl.filteredAgencies = ctrl.agencies || [];
		emitExpandedChanged();
		focusAgencySearch();
	}

	function emitExpandedChanged() {
		if(ctrl.onExpandedChanged) {
			ctrl.onExpandedChanged({ $event: { isExpanded: ctrl.isAgencyListExpanded } });
		}
	}

	function focusAgencySearch() {
		$timeout(() => {
			const searchInput = document.getElementById(ctrl.searchInputId);
			searchInput?.focus();
			searchInput?.select();
		});
	}
}

export default angular.module("vesl.components.agency-picker", []).component("agencyPicker", {
	controller,
	template,
	bindings: {
		agencies: "<",
		selectedAgency: "<",
		autoSelectInitial: "<?",
		openWhenEmpty: "<?",
		placeholderText: "@",
		onAgencySelected: "&",
		onExpandedChanged: "&?"
	}
}).name;
